import { Injectable, InjectionToken, computed, effect, inject, signal } from '@angular/core';

export const COLOR_MODE_KEY = new InjectionToken<string>('ColorModeKey');

@Injectable({
  providedIn: 'root'
})
export class ColorMode {
  private readonly storageKey = inject(COLOR_MODE_KEY, { optional: true });

  public readonly selectedScheme = signal<'light' | 'dark' | 'system'>('light');
  public readonly currentMode = computed(() =>
    this.selectedScheme() === 'system' ? this.preference : this.selectedScheme()
  );

  private preference: 'light' | 'dark' = 'light';

  constructor() {
    this.preference = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

    if (this.storageKey) {
      const savedMode = localStorage.getItem(this.storageKey) as 'light' | 'dark' | 'system' | null;
      if (savedMode) {
        this.selectedScheme.set(savedMode);
      }

      effect(() => localStorage.setItem(this.storageKey || 'color-mode', this.selectedScheme()));
      effect(() => document.documentElement.setAttribute('data-bs-theme', this.currentMode()));
    }
  }
}
